import React, {createContext} from 'react';
const PersonaPageContext = createContext(null);
/**
 * PersonaPageContext value:
 * {
 *   ...
 *   group: object | null,
 *   setGroup: (group: object | null) => void,
 *   ...
 * }
 */
export {PersonaPageContext};